import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BaseResizableComponent } from '@src/app/modules/base';
import { NavigationItem, SETTINGS_NAVIGATION } from '@src/app/modules/navigation';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsComponent extends BaseResizableComponent {
  private readonly router = inject(Router);

  selectedItem?: NavigationItem;

  readonly navTree = SETTINGS_NAVIGATION;

  get showFullPage(): boolean {
    return !this.selectedItem || this.isLargeScreen;
  }

  onClickReturnButton() {
    this.selectedItem = undefined;
    this.router.navigate(['settings']);
  }
}
